/* eslint-disable no-unused-vars, max-len */
const { feWp } = window;
const { addAction } = feWp.hooks;

// Function to stop autoplay on the slider object
const stopAutoPlay = ( sliderObj ) => {
  sliderObj.autoplay.stop();
};

const updateProgressBar = ( swiper ) => {
  const progressBarFill = swiper.el.querySelector( '.swiper-pagination-progressbar-fill' );
  const activeSlide = swiper.realIndex + 1;
  const progress = ( ( activeSlide / ( swiper.originalSlideCount ) ) ) * 100;
  if ( progressBarFill ) {
    progressBarFill.style.width = progress + '%';
  }
};

const updateDots = ( swiper ) => {
  const dots = swiper.el.querySelectorAll( '.swiper-pagination-bullet' );
  dots.forEach( dot => {
    dot.addEventListener( 'click', () => {
      stopAutoPlay( swiper );
    } );
  } );
};

const createProgressFillElement = ( bullet ) => {
  if ( bullet.querySelector( '.bullet-progress-fill' ) ) return;
  
  const progressFill = document.createElement( 'span' );
  progressFill.className = 'bullet-progress-fill';
  progressFill.style.width = '0%';
  progressFill.style.animation = 'none';
  bullet.appendChild( progressFill );
};

const resetProgressFill = ( fill ) => {
  fill.style.animation = 'none';
  fill.style.width = '0%';
  fill.classList.remove( 'paused' );
};

const resetAllProgressBars = ( bullets ) => {
  bullets.forEach( bullet => {
    const fill = bullet.querySelector( '.bullet-progress-fill' );
    if ( fill ) {
      resetProgressFill( fill );
    }
  } );
};

const pauseAllProgressBars = ( bullets ) => {
  bullets.forEach( bullet => {
    const fill = bullet.querySelector( '.bullet-progress-fill' );
    if ( fill ) {
      fill.classList.add( 'paused' );
    }
  } );
};

const resumeActiveProgressBar = ( bullets, activeIndex ) => {
  const activeBullet = bullets[activeIndex];
  if ( !activeBullet ) return;
  
  const fill = activeBullet.querySelector( '.bullet-progress-fill' );
  if ( fill ) {
    fill.classList.remove( 'paused' );
  }
};

const startProgressAnimation = ( fill, autoplayDelay ) => {
  fill.style.animation = `bulletProgressFill ${autoplayDelay}ms linear forwards`;
  fill.classList.remove( 'paused' );
};

const initBulletProgressBars = ( swiper ) => {
  const testimonialSlider = document.querySelector( '.e-stn--full-width-testimonial-slider .swiper' );
  if ( !testimonialSlider || swiper.el !== testimonialSlider ) return;

  const pagination = swiper.el.querySelector( '.swiper-pagination' );
  if ( !pagination ) return;

  const bullets = pagination.querySelectorAll( '.swiper-pagination-bullet' );
  const autoplayDelay = swiper.params.autoplay?.delay || 3000;
  let currentActiveIndex = -1;
  let animationTimeout = null;

  bullets.forEach( createProgressFillElement );

  const startProgress = ( bulletIndex ) => {
    if ( currentActiveIndex === bulletIndex ) return;
    if ( animationTimeout ) {
      clearTimeout( animationTimeout );
      animationTimeout = null;
    }

    resetAllProgressBars( bullets );

    const activeBullet = bullets[bulletIndex];
    if ( !activeBullet ) return;

    const fill = activeBullet.querySelector( '.bullet-progress-fill' );
    if ( !fill ) return;

    currentActiveIndex = bulletIndex;
    animationTimeout = setTimeout( () => {
      startProgressAnimation( fill, autoplayDelay );
      animationTimeout = null;
    }, 10 );
  };

  const setupEventHandlers = () => {
    swiper.on( 'slideChange', () => {
      startProgress( swiper.realIndex );
    } );

    swiper.on( 'autoplayStop', () => {
      pauseAllProgressBars( bullets );
    } );

    swiper.on( 'autoplayStart', () => {
      resumeActiveProgressBar( bullets, swiper.realIndex );
    } );
  };

  const initProgress = () => {
    currentActiveIndex = -1;
    startProgress( swiper.realIndex );
  };

  setupEventHandlers();

  requestAnimationFrame( () => {
    requestAnimationFrame( initProgress );
  } );
};

//Enable slide click-to-activate for resource slider
const enableSlideClickToActive = ( swiper, el ) => {
  const section = el.closest( '.e-stn--resource-slider-with-arrows' );
  if ( !section ) return;

  swiper.slides.forEach( ( slide, domIndex ) => {
    if ( slide._b3rgClickToActive ) {
      slide.removeEventListener( 'click', slide._b3rgClickToActive );
    }

    slide._b3rgClickToActive = function( e ) {
      if ( slide.classList.contains( 'swiper-slide-active' ) ) return;
      stopAutoPlay( swiper );

      swiper.slideTo( domIndex );
    };

    slide.addEventListener( 'click', slide._b3rgClickToActive, false );
  } );
};

addAction(
  'b3rg_slider_init',
  'b3rg/slider',
  ( settings, el, swiper ) => {
    const isInfinite = settings.loop;
    const isProgressbar = settings.pagination?.type;
    const isAutoHeight = settings.autoHeight;
    
    // Skip infinite loop modifications when adaptive height is enabled to prevent slider getting stuck
    if ( isInfinite && !isAutoHeight ) {
      swiper.params.supports4k = true;
      swiper.params.longSwipesRatio = 0;
      swiper.params.threshold = 0;
      swiper.params.touchRatio = 0.1;
      swiper.params.autoplay = {
        delay: settings?.autoplay?.delay || 3000,
      };
      if ( isProgressbar ) {
        swiper.params.pagination = {
          el: '.swiper-pagination',
          type: 'custom',
          renderCustom: function ( swiper, current, total ) {
            return '<div class="swiper-pagination-wrpr"><span class="swiper-pagination-progressbar-fill"></span></div><div class="swiper-fraction-custom">' +
              current +
              '/' + ( swiper.originalSlideCount ) + '</div>';
          },
          renderFraction: function () {
            return '';
          }
        };
        el.querySelector( '.swiper-pagination' ).classList.add( 'swiper-pagination-custom' );
        swiper.on( 'slideChange', function () {
          updateProgressBar( this );
        } );
        swiper.on( 'init', function () {
          // Update the progress bar on initialization
          updateProgressBar( this );
        } );
      }
      swiper.update();
    }
    enableSlideClickToActive( swiper, el );
    swiper.on( 'afterInit', ( swiper )=> {
      updateDots( swiper );
      initBulletProgressBars( swiper );
    } );
    
    const arrows = swiper.el.querySelectorAll( '.e-sld__btn' );
    arrows.forEach( arrow => {
      arrow.addEventListener( 'click', () => {
        stopAutoPlay( swiper );
      } );
    } );
    swiper.on( 'click', function () {
      stopAutoPlay( swiper );
    } );
    swiper.on( 'touchStart', function () {
      stopAutoPlay( swiper );
    } );
    // Prevent additional swipes during the transition
    swiper.on( 'slideChangeTransitionStart', () => {
      swiper.allowTouchMove = false;
    } );
    // Re-enable touch dragging after the transition
    swiper.on( 'slideChangeTransitionEnd', () => {
      swiper.allowTouchMove = true;
    } );
    swiper.on( 'slideChange', () => {
      enableSlideClickToActive( swiper, el );
    } );
  },
  10,
  1,
);